module.exports = __webpack_public_path__ + "img/Stickers.bf6cf713.png";